import { useLang } from "@/context/LangContext";

export default function LanguageToggle() {
  const { lang, setLang } = useLang();
  return (
    <div className="inline-flex items-center rounded-full border border-[#0d3b66]/15 p-0.5 bg-white/70 backdrop-blur">
      {["en", "tr"].map((k) => (
        <button
          key={k}
          data-testid={`lang-toggle-${k}`}
          onClick={() => setLang(k)}
          className={`px-3 py-1 text-xs font-medium rounded-full ${
            lang === k ? "bg-[#0d3b66] text-[#f4a261]" : "text-[#0d3b66] hover:bg-[#0d3b66]/5"
          }`}
        >
          {k.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
